module.exports = __webpack_public_path__ + "assets/img/32_640.8eb03450.jpg";